module.exports = __webpack_public_path__ + "assets/nginx.cf88c07a.svg";